import { LandingPageRedirectOptions } from 'Client/components/OneHeader/DynamicSearch/searchService';

const findLandingPageRedirect = (landingPageSuggestions: LandingPageRedirectOptions, searchValue: string): string => {
    let redirectPath = '';
    if (landingPageSuggestions && searchValue) {
        Object.entries(landingPageSuggestions).forEach(item => {
            const [type, synonyms] = item;
            Object.keys(synonyms).forEach(path => {
                if (!redirectPath && synonyms[path].includes(searchValue.toLocaleLowerCase())) {
                    redirectPath = type === 'landings' ? `/n/${path}/` : `/${type}/${path}/`;
                }
            });
        });
    }
    return redirectPath;
};

export default findLandingPageRedirect;
